import { createContext, useContext, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

const AuthCtx = createContext(null);

function loadUser() {
  try {
    return JSON.parse(localStorage.getItem("gt_user"));
  } catch {
    return null;
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(loadUser);

  const login = (data) => {
    const u = { role: data.role, profile: data.profile };
    localStorage.setItem("gt_token", data.token);
    localStorage.setItem("gt_user", JSON.stringify(u));
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem("gt_token");
    localStorage.removeItem("gt_user");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export function RequireRole({ role, children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (!user || user.role !== role) {
    return <Navigate to={role === "admin" ? "/admin/login" : "/login"} state={{ from: location }} replace />;
  }
  return children;
}
